export default __webpack_public_path__ + "static/media/hori-dark.6a2835f0.png";